import React, { type ComponentProps } from 'react';

import { BodyText } from '@garnish/core';

// ─────────────────────────────────────────────────────────────────────────────

export const ProductCardV2Heading = (props: ProductCardV2HeadingProps) => {
  const { children, sizeMatch = DEFAULT_SIZE_MATCH } = props;

  return (
    <BodyText bold sizeMatch={sizeMatch}>
      {children}
    </BodyText>
  );
};

// ─── Constants ───────────────────────────────────────────────────────────────

const DEFAULT_SIZE_MATCH: SizeMatch = ['24'];

// ─── Types ───────────────────────────────────────────────────────────────────

type ProductCardV2HeadingProps = {
  children: string;
  sizeMatch?: SizeMatch;
};

type SizeMatch = ComponentProps<typeof BodyText>['sizeMatch'];
